import edit from "./views/edit_questionnaire.vue";
import pcSub from "./views/pc_sub.vue";
import h5Sub from "./views/h5_sub.vue";
import QSDK from "src/model/q_sdk";
import { handleSaasBaseUrl, setEnv } from "src/api/questionnaire-service";
import CONST from "src/model/const";
import RES from "src/utils/res";
import VueI18n from "vue-i18n";
import languages from "./lang/index.js";
import { setMessage } from "./utils/message";

let Vue = window.Vue;
const handler = Symbol("clientList");
let i18n;
const defaultOptions = {
  notify: true,
  auth: {
    client: "js",
    package_check: "peter",
  },
};
/**
 * 问卷服务类
 * @param {Object} options 初始化参数
 *   notify:true, // 是否开启消息提示，默认数true
 *   env: 'test', // 环境：paasapi会根据该参数设置域名
 *   auth:{
 *      app_id paas的应用id
 *      third_party_user_id paas的第三方用户id
 *      access_token paas的授权token
 *      sign paas的授权签名
 *   }
 */
class QService {
  constructor(options = {}) {
    this.res = [];
    this.options = Object.assign({}, defaultOptions, options);
    this.sdk = new QSDK(this.options.auth); // ajax 方法

    //初始化完成标志
    this.READY_STATUS = false;

    // 处理paas api
    setEnv({ env: this.options.env, saasBaseUrl: options.saasBaseUrl });

    // 处理saas api
    this.saasBaseUrl = handleSaasBaseUrl(options.saasBaseUrl);

    this.loadJS();
  }

  loadJS() {
    if (!window.Vue) {
      this.res.push(RES.VUE);
    } else {
      let vueVersion = window.Vue.version.replace(/\./g, "");
      vueVersion = vueVersion.padEnd(4, "0") * 1;
      if (vueVersion < 2516) {
        this.sdk.fire(CONST.EVENT.ERROR, "vue请使用2.6.14版本");
      }
    }

    if (!window.VHALLUI) {
      this.res.push(RES.VHALLCSS);
      this.res.push(RES.VHALLJS);
    }
    if (!window.initNECaptcha) {
      this.res.push(RES.YIDUNJS);
    }

    if (this.res.length == 0) {
      this.init();
    } else {
      const cssExpr = new RegExp("\\.css");
      let dHead = document.head || document.getElementsByTagName("head")[0];
      let loadAll = [];
      for (let i = 0; i < this.res.length; i++) {
        let p = new Promise((resolve, reject) => {
          let node = null;
          if (cssExpr.test(this.res[i])) {
            node = document.createElement("link");
            node.rel = "stylesheet";
            node.href = this.res[i];
          } else {
            node = document.createElement("script");
            node.src = this.res[i];
          }
          node.onload = () => {
            resolve(true);
          };
          node.onerror = (e) => {
            reject(e);
          };
          dHead.appendChild(node);
        });
        loadAll.push(p);
      }
      Promise.all(loadAll)
        .then(() => {
          Vue = window.Vue;
          this.init();
        })
        .catch((err) => {
          this.sdk.fire(CONST.EVENT.ERROR, err);
        });
    }
  }
  /**
   * 初始化
   */
  init() {
    Vue.use(VueI18n);
    // Vuei18n增加方法，匹配不到code返回undefined
    Vue.prototype.$tec = function (path) {
      return this.$te(path) ? this.$t(path) : undefined;
    };
    setMessage();

    i18n = new VueI18n({
      locale: this.options.locale || "zh-CN", // 设置地区
      messages: {
        "zh-CN": languages.zh,
        en: languages.en,
        es: languages.spain,
      },
      silentTranslationWarn: true,
    });

    setTimeout(() => {
      this.READY_STATUS = true;
      this.sdk.fire(CONST.EVENT.READY);
    }, 0);
  }
  $on(type, callback) {
    this.sdk.on(type, callback);
  }
  $http(method, data) {
    return this.sdk[method](data);
  }
  renderPageEdit(target, id = 0) {
    if (!this.READY_STATUS) {
      this.sdk.fire(CONST.EVENT.ERROR, "未初始化完成");
      this.loadJS();
    }
    const ComConstructor = Vue.extend(edit);
    // Vue.extend扩展构造器利用propsData传递数据
    const vm = new ComConstructor({
      i18n: i18n,
      propsData: {
        id: id,
        sdk: this.sdk,
        notify: this.options.notify,
        saasBaseUrl: this.saasBaseUrl,
        isPlayBackSet: this.options.isPlayBackSet, // 回放设置开关
        addTitle: this.options.addTitle, // 创建标题
        i18nLocal: i18n.locale,
        webinarId: this.options.webinarId,
        businessUid: this.options.businessUid,
      },
    });

    vm.$options.i18n = i18n;
    this[handler](vm, CONST.EVENT.CREATE);
    this[handler](vm, CONST.EVENT.UPDATE);
    this[handler](vm, CONST.EVENT.ERROR);
    const instance = vm.$mount();
    console.log(instance);
    document.querySelector(target).appendChild(instance.$el);
  }
  renderPagePC(target, id, config) {
    if (!this.READY_STATUS) {
      this.sdk.fire(CONST.EVENT.ERROR, "未初始化完成");
      this.loadJS();
    }
    const ComConstructor = Vue.extend(pcSub);
    var config = Object.assign(
      {
        isPreview: false,
        isPc: true,
      },
      config
    );
    const vm = new ComConstructor({
      i18n: i18n,
      propsData: {
        id: id,
        sdk: this.sdk,
        notify: this.options.notify,
        defaultPhone: this.options.iphoneNumber,
        config,
        showVhPrivacy: this.options.showVhPrivacy || false,
        i18nLocal: i18n.locale,
        tpSubmit: this.options.tpSubmit,
        webinarId: this.options.webinarId,
        businessUid: this.options.businessUid,
      },
    });
    vm.$options.i18n = i18n;
    console.log("111111", vm);
    this[handler](vm, CONST.EVENT.SUBMIT);
    this[handler](vm, CONST.EVENT.ERROR);
    this[handler](vm, CONST.EVENT.MYREWARD);
    const instance = vm.$mount();
    document.querySelector(target).appendChild(instance.$el);
  }
  renderPageH5(target, id, config) {
    if (!this.READY_STATUS) {
      this.sdk.fire(CONST.EVENT.ERROR, "未初始化完成");
      this.loadJS();
    }
    const ComConstructor = Vue.extend(h5Sub);
    var config = Object.assign(
      {
        isPreview: false,
        isPc: true,
      },
      config
    );
    const vm = new ComConstructor({
      i18n: i18n,
      propsData: {
        id: id,
        sdk: this.sdk,
        notify: this.options.notify,
        defaultPhone: this.options.iphoneNumber,
        config,
        showVhPrivacy: this.options.showVhPrivacy || false,
        i18nLocal: i18n.locale,
        tpSubmit: this.options.tpSubmit,
        webinarId: this.options.webinarId,
        businessUid: this.options.businessUid,
      },
    });
    vm.$options.i18n = i18n;
    this[handler](vm, CONST.EVENT.SUBMIT);
    this[handler](vm, CONST.EVENT.ERROR);
    this[handler](vm, CONST.EVENT.MYREWARD);
    const instance = vm.$mount();
    document.querySelector(target).appendChild(instance.$el);
  }
  [handler](vm, type) {
    vm.$on(type, (data) => {
      this.sdk.fire(type, data);
    });
  }

  // 设置问卷sdk的版本号
  static get version() {
    return VERSION;
  }
}

export default QService;
